const API_URL = process.env.REACT_APP_API_URL;

async function handleResponse(response) {
    if (!response.ok) {
        const errorData = await response.json();
        return { error: true, message: errorData.message || 'Network error' };
    }
    return { error: false, data: await response.json() };
}

async function fetchData(url, options = {}) {
    try {
        const response = await fetch(url, options);
        return await handleResponse(response);
    } catch (error) {
        console.error('Error during fetch request:', error);
        return { error: true, message: error.message };
    }
}

export async function fetchCustomPlants() {
    return fetchData(`${API_URL}/customPlants/`);
}

export async function fetchCustomPlant(customPlantId) {
    if (!customPlantId) {
        console.error('No customPlantId provided');
        return { error: true, message: 'customPlantId is required' };
    }
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return fetchData(`${API_URL}/customPlants/${encodeURIComponent(customPlantId)}`, options);
}

export async function fetchCustomPlantsByName(name) {
    if (!name.trim()) {
        console.error('No valid name provided');
        return { error: true, message: 'The name cannot be empty' };
    }
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetchData(`${API_URL}/customPlants/byName/${encodeURIComponent(name)}`, options);
}

export async function createCustomPlant(customPlant, token) {
    if (!customPlant || Object.keys(customPlant).length === 0) {
        console.error('Invalid data for custom plant');
        return { error: true, message: 'Custom plant data is invalid or empty' };
    }
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(customPlant),
    };
    return fetchData(`${API_URL}/customPlants/add`, options);
}

export async function updateCustomPlant(customPlantId, customPlant, token) {
    if (!customPlantId || !customPlant) {
        console.error('Invalid input for updating custom plant');
        return { error: true, message: 'Both customPlantId and customPlant data are required' };
    }
    const options = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(customPlant),
    };
    return fetchData(`${API_URL}/customPlants/${encodeURIComponent(customPlantId)}`, options);
}

export async function deleteCustomPlant(customPlantId, token) {
    if (!customPlantId) {
        console.error('No customPlantId provided for deletion');
        return { error: true, message: 'customPlantId is required for deletion' };
    }
    const options = {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    return fetchData(`${API_URL}/customPlants/${encodeURIComponent(customPlantId)}`, options);
}
